'use client';

import { useEffect } from 'react';

interface CustomScriptsProps {
  scripts: string;
  target: 'head' | 'body';
}

export default function CustomScripts({ scripts, target }: CustomScriptsProps) {
  useEffect(() => {
    if (!scripts) return;

    try {
      const parser = new DOMParser();
      const parsedDoc = parser.parseFromString(scripts, 'text/html');
      const elementsToInject = Array.from(parsedDoc.head.childNodes).concat(
        Array.from(parsedDoc.body.childNodes)
      );

      const addedNodes: Node[] = [];
      const parent = target === 'head' ? document.head : document.body;

      elementsToInject.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          const element = node as HTMLElement;
          if (element.tagName === 'SCRIPT') {
            const script = document.createElement('script');
            // Copy all attributes
            Array.from(element.attributes).forEach((attr) => {
              script.setAttribute(attr.name, attr.value);
            });
            script.text = element.textContent || '';
            parent.appendChild(script);
            addedNodes.push(script);
          } else {
            const cloned = element.cloneNode(true);
            parent.appendChild(cloned);
            addedNodes.push(cloned);
          }
        }
      });

      return () => {
        addedNodes.forEach((node) => {
          if (node.parentNode) {
            node.parentNode.removeChild(node);
          }
        });
      };
    } catch (error) {
      console.error('Failed to inject custom scripts:', error);
    }
  }, [scripts, target]);

  return null;
}
